// MapMonitoring/services/layerService.ts
import { MapLayerType, LayerConfig, LayersConfig } from "../types";

export class LayerService {
    static createLayerConfig(
        type: MapLayerType,
        zIndex: number,
        visible: boolean = true,
        name?: string,
        description?: string
    ): LayerConfig {
        return {
            type,
            visible,
            zIndex,
            name: name || this.getDefaultLayerName(type),
            description,
        };
    }

    static getDefaultLayerName(type: MapLayerType): string {
        const names: Record<MapLayerType, string> = {
            basePoints: "КП (контрольные точки)",
            tsPoints: "ТС",
            customMarks: "Пользовательские метки",
            drawnShapes: "Нарисованные фигуры",
            restrictedZones: "Зоны ограничений",
            routes: "Маршруты",
            routePoints: "Точки маршрутов",
            routeLabels: "Подписи маршрутов",
        };
        return names[type] || type;
    }

    static createDefaultLayersConfig(): LayersConfig {
        return {
            basePoints: this.createLayerConfig("basePoints", 10, true),
            tsPoints: this.createLayerConfig("tsPoints", 20, true),
            customMarks: this.createLayerConfig("customMarks", 30, true),
            drawnShapes: this.createLayerConfig(
                "drawnShapes",
                35,
                true,
                "Фигуры",
                "Линии/полигоны, нарисованные на карте"
            ),
            restrictedZones: this.createLayerConfig("restrictedZones", 40, true),
            routes: this.createLayerConfig("routes", 100, true),
            routePoints: this.createLayerConfig("routePoints", 110, true),
            routeLabels: this.createLayerConfig("routeLabels", 120, true),
        };
    }

    static updateLayerVisibility(
        config: LayersConfig,
        layerType: MapLayerType,
        visible: boolean
    ): LayersConfig {
        return {
            ...config,
            [layerType]: {
                ...config[layerType],
                visible,
            },
        };
    }

    static updateLayerZIndex(
        config: LayersConfig,
        layerType: MapLayerType,
        zIndex: number
    ): LayersConfig {
        return {
            ...config,
            [layerType]: {
                ...config[layerType],
                zIndex,
            },
        };
    }

    static getLayersOrder(config: LayersConfig): MapLayerType[] {
        return Object.entries(config)
            .sort(([, a], [, b]) => a.zIndex - b.zIndex)
            .map(([type]) => type as MapLayerType);
    }

    static validateLayerConfig(config: LayerConfig): boolean {
        return !!(
            config.type &&
            typeof config.visible === "boolean" &&
            typeof config.zIndex === "number" &&
            config.name
        );
    }
}
